import { render } from "./DialogCreateComponent.vue?vue&type=template&id=36a821fa&scoped=true"
import script from "./DialogCreateComponent.vue?vue&type=script&lang=js"
export * from "./DialogCreateComponent.vue?vue&type=script&lang=js"

import "./DialogCreateComponent.vue?vue&type=style&index=0&id=36a821fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a821fa"]])

export default __exports__